import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Global interceptor: redirect to login on 401
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const url = error.config?.url || "";
      // Don't redirect for auth check calls (/auth/me) or public pages
      const isAuthCheck = url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
      const isPublicPage = ["/login", "/registro", "/forgot-password", "/reset-password", "/"].includes(path) || path.startsWith("/cotizar");
      if (!isAuthCheck && !isPublicPage) {
        window.location.href = "/login";
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default API;
